/**
 *
 * PagiCardsLoadingEl
 *
 */
import React, { memo } from 'react';
import { Grid, Box, Hidden } from '@mui/material';
import CardLayout from '../CardLayout';
import Skeleton from 'react-loading-skeleton';

const LoadingCard: React.FC = () => (
  <Grid item xs={12} sm={12} md={6} lg={4} xl={3}>
    <CardLayout
      title={<Skeleton />}
      subheader={<Skeleton />}
      cardContent={[...Array(3)].map((_d, index) => (
        <Box mb={1} key={index}>
          <Skeleton />
        </Box>
      ))}
      cardAction={
        <Box ml={1}>
          <Skeleton width={50} />
        </Box>
      }
    />
  </Grid>
);

export const PagiCardsLoadingEl = memo(() => {
  return (
    <>
      <Box mb={2}>
        <Grid container spacing={2}>
          <LoadingCard />
          <Hidden xlDown>
            <LoadingCard />
          </Hidden>
          <Hidden mdDown>
            <LoadingCard />
          </Hidden>
          <Hidden lgDown>
            <LoadingCard />
          </Hidden>
        </Grid>
      </Box>
    </>
  );
});
